import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import { getXsrfToken } from "../cgi/cookies";
import { DriveRequest } from "../common/drive-request";
import { requestV1Cgi } from "../data-source/network-request";

/**
 * 拉取版本管理列表
 */
export function getDriveVersionsList(params) {
  return new DriveVersionsListRequest(params).send();
}
/**
 * 拉取版本管理列表
 */
export var DriveVersionsListRequest = /*#__PURE__*/function (_DriveRequest) {
  _inherits(DriveVersionsListRequest, _DriveRequest);
  var _super = _createSuper(DriveVersionsListRequest);
  function DriveVersionsListRequest() {
    _classCallCheck(this, DriveVersionsListRequest);
    return _super.apply(this, arguments);
  }
  _createClass(DriveVersionsListRequest, [{
    key: "request",
    value: function request(payload) {
      return requestV1Cgi(payload);
    }
  }, {
    key: "getPayload",
    value: function getPayload(params) {
      return {
        method: 'post',
        url: '/api/drive/versions/list',
        data: {
          file_id: params.file_id,
          xsrf: getXsrfToken()
        }
      };
    }
  }, {
    key: "getResult",
    value: function getResult(response) {
      return response.result;
    }
  }]);
  return DriveVersionsListRequest;
}(DriveRequest);
//# sourceMappingURL=versions-list.js.map